import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { buildWorkspaceDashboardPath } from "@/features/Workspaces/workspaceRoutes";

const useUUID = (userViews?: Record<string, any>) => {
  const { uuid, group, workspace } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const setUUID = (newUUID: string) => {
    if (!group || !workspace) return;
    navigate(
      buildWorkspaceDashboardPath({
        group,
        workspace,
        uuid: newUUID,
      }),
    );
  };

  useEffect(() => {
    // if no uuid navigate to the first available uuid
    if (!uuid) {
      const defaultUUID = Object.keys(userViews || {})[0];
      setUUID(defaultUUID);
    }
  }, [uuid, userViews, group, workspace, location.pathname]);

  return { uuid, setUUID };
};

export default useUUID;
